import type { CartItemResponse } from '@/features/cart/types';

/**
 * Totals for a specific currency
 */
export interface CurrencyTotals {
  subtotal: number;
  platformFee: number;
  total: number;
  currency: string;
}

/**
 * Calculate totals grouped by currency
 */
export function calculateTotalsByCurrency(items: CartItemResponse[]): Record<string, CurrencyTotals> {
  const totals: Record<string, CurrencyTotals> = {};

  items.forEach(item => {
    if (!item.currency) {
      console.warn('Cart item missing currency, skipping:', item.id);
      return;
    }
    const currency = item.currency;

    if (!totals[currency]) {
      totals[currency] = {
        subtotal: 0,
        platformFee: 0,
        total: 0,
        currency
      };
    }

    totals[currency].subtotal += item.subtotal;
    totals[currency].platformFee += item.platform_fee;
    totals[currency].total += (item.subtotal + item.platform_fee);
  });

  return totals;
}

/**
 * Calculate subtotal from cart items (Legacy - sums all regardless of currency)
 * @deprecated Use calculateTotalsByCurrency instead for multi-currency support
 */
export function calculateSubtotal(items: CartItemResponse[]): number {
  return items.reduce((sum, item) => sum + item.subtotal, 0);
}

/**
 * Calculate total platform fees from cart items (Legacy - sums all regardless of currency)
 * @deprecated Use calculateTotalsByCurrency instead for multi-currency support
 */
export function calculatePlatformFees(items: CartItemResponse[]): number {
  return items.reduce((sum, item) => sum + item.platform_fee, 0);
}

/**
 * Calculate total price (subtotal + platform fees) from cart items (Legacy - sums all regardless of currency)
 * @deprecated Use calculateTotalsByCurrency instead for multi-currency support
 */
export function calculateTotalPrice(items: CartItemResponse[]): number {
  return items.reduce((sum, item) => sum + item.subtotal + item.platform_fee, 0);
}
